<template>
  <div class="toggle-btn-container">
    <v-switch
      @click="toggleLayer()"
      v-model="checkbox"
      :label="this.buttonLabel"
      color="blue"
    ></v-switch>
  </div>
</template>
<script>
import { EventBus } from "../../data/EventBus";
import { Config } from "../../data/Config/Config";
//const querystring = require('querystring');
import queryString from 'query-string';

export default {
  name: "LayerToggleButton",
  props: ["layerid", "buttonLabel", "isChoroLayer", "defaultOn"],
  components: {},
  data: function () {
    return {
      checkbox: false,
    };
  },
  mounted: function () {
    ////let _map = this.$store.getters.getMap;
    //console.log(_map)
    const configLayer = Config.layersConfig.layerArray.filter(
      (l) => l.id === this.layerid[0]
    );
    if (typeof configLayer !== 'undefined' && configLayer.length === 0) {
      this.checkbox = this.defaultOn || false;
      console.error("error setting checbox default");
    } else {
      this.checkbox = (configLayer[0].layout.visibility === "visible");
    }

    const searchObj = queryString.parse(window.location.search.substring(1));
   /// console.log(Object.keys(qObj))
    if(this.layerid[0].includes('tract-cvap')){
      this.checkbox = searchObj['tractLayer'] === 'true' || false
    }

    if(this.layerid[0].includes('tract-vap')){
      this.checkbox = searchObj['tractVAPLayer'] === 'true' || false
    }

    if(this.layerid[0].includes('voting')){
      console.log(this.layerid[0])
      this.checkbox = searchObj['voterLayer'] === 'true' || false
    }

    EventBus.$on("toggle-legend-layer",(id, val)=>{
       if(this.layerid.indexOf(id)===-1 && val === true && !this.layerid[0].includes('count') && !id.includes('count')){
         this.checkbox = false;
       }
    });
  },
  methods: {
    toggleLayer: function () {
      
      for (let l in this.layerid) {
        if(this.layerid[l] === 'tract-vap'){
          this.$store.commit('setVapLayerOn', this.checkbox);      
        }else{
          this.$store.commit('setVapLayerOn', !this.checkbox);
        }
        EventBus.$emit(
          "toggle-legend-layer",
          this.layerid[l],
          this.checkbox,
          this.isChoroLayer
        );
      }

      //console.log('turn other layers to'+ ' '+!this.checkbox)
      //console.log('toggle '+this.layerid+' '+this.checkbox)
      //this.$store.commit("setMapColumn", this.layerType);
    },
  },
};
</script>
<style scoped>
.toggle-btn-container {
  display: inline-block;
}
/* .toggle-btn-container .v-input{
        padding: 0 25px;
    height: 1.5em;
} */
</style>